export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_LOGING_IN = 'SET_LOGING_IN';
export const SET_AUTHNETICATED_USER = 'SET_AUTHNETICATED_USER';
export const INIT_USER = 'INIT_USER';
export const INIT_AUTHENTICATED_USER = 'INIT_AUTHENTICATED_USER';
